module.exports = __webpack_public_path__ + "img/客厅_image.1f219217.png";